import { gql } from "@apollo/client";

export const GetTransQuery=gql`
query GetTransJob($id: bigint = "") {
  cng_gogas_transaction_jobs_by_pk(id: $id) {
    state
    id
  }
}
`